import { useCount } from "@/global-state/global.state";
import { pages } from "@/services/requests";
import { usePathname } from "next/navigation";
import { SetStateAction } from "react";
import { useQuery } from "react-query";

interface Props {
  params: any;
  setPaginationData: SetStateAction<any>;
}

export default function useSearch({ params, setPaginationData }: Props) {
  const { count } = useCount();
  const pathname = usePathname();

  const { data, isFetching, refetch } = useQuery(
    ["SEARCH", params, pathname],
    pages.getSearch,
    {
      onSuccess: (data) => {
        if (count > 1) {
          setPaginationData((prev) => [...prev, ...data.data]);
        } else {
          setPaginationData(data.data);
        }
      },
    }
  );

  return { data, isFetching, refetch };
}
